import React, { useState } from 'react'
import { Ratio } from 'react-bootstrap'
import styles from './index.module.css'
import { useDispatch,useSelector } from 'react-redux';
import { setUndoS } from '../../store/modules/tabplate';

export default function Btnundo() {
  const [isPressed,setIsPressed]=useState(false)
  const {jy,un}=useSelector((state)=>state.tabplate);
  const dispatch=useDispatch();
  
  // 功能键背景色
  const {bm}=useSelector((state)=>state.colorplate);

  function clickUndo() {
    if(un!==1 && jy.length > 1){
      const u = (un===0) ? jy.length-1 : un
      const nid=jy[u].id
      const nold=jy[u].dold
      dispatch(setUndoS({nid:nid,nold:nold,un:u-1}));
    }
  }

  const handleClickDown = () => {
    setIsPressed(true);
  }
  const handleClickUp = () => {
    setIsPressed(false);
    clickUndo();
  }

  return (
    <Ratio aspectRatio={"1x1"}>
    <div 
      onMouseDown={handleClickDown}
      onMouseUp={handleClickUp}
    >
      <div
        className={`${styles.b_u_adiv} ${isPressed ? styles.pressed : ''}`}
        style={{backgroundColor:bm}}
      >
        <img role="img" src='./pic/reply.svg' alt="" className={styles.b_u_img}/>
      </div>
    </div>
    </Ratio>
  )
}
